import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import TeamCard from '../Components/TeamCard/TeamCard'
import './whitepaper.css'
import team1 from '../img/Avatar5.png'
import team3 from '../img/Avaar.png'
import team4 from '../img/Avatar1.png'
import team5 from '../img/quesionmark.jpg'
import codeimage from '../img/CodeIcon.png'
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
const Whitepaperbody = () => {

  return (
    <div className="pcc---slider py-5">
      <Container>
        <Grid
          container
          justify="center"
        >
          <Grid
            container
            justify="center"
            md={8}
            className="mt-5 py-md-5"
          >
            <h1>TOKENOMICS</h1>
          </Grid>
          <Grid
            container
            justify="center"
            md={8}
          >
            {/* <AppBar position="static" className="px-lg-5 mb-4">
                        <Tabs value={value} onChange={handleChange}>
                        <Tab label="TOKENOMICS" {...a11yProps(0)} />
                        <Tab label="DISTRIBUTION" {...a11yProps(1)} />
                        <Tab label="OUR VISION" {...a11yProps(2)} />
                        </Tabs>
                    </AppBar> */}
            
              <p className="text-center">
                <h4>Whitepaper</h4>
                <p>• 10,000,000,000 tokens are in total supply, all of which are in open circulation.</p>

                <p>• 4.5% of all transactions goes to liquidity.</p>

                <p>• 4.5% of all transactions are given as BNB Rewards. Half of these rewards go to holders and the rest to the maintenance wallet.</p>

                <p>• 1% of all transactions are provided as pCatV3 rewards to holders.</p>

                <p>• 100 BNB Presale on Unicrypt.</p>

                <p>• 80% of presale funds go to liquidity.</p>

                <p>• No team tokens.</p>

                <p>• No marketing tokens.</p>

                <p>• Community built.</p>

                <p>• Anti-Whale so that no one dumps like safe moon. Above certain % or moving between two wallets have 2 bnb tax.</p>

                <p>• Low buy and sell fees.</p>

                <p>• PCatV3 operates on Binance Smart Chain, transaction fees are ranged within 4c to 24 cents.</p>

                <p>• Lightning fast transaction speeds. Average transaction time on BSC is 3 seconds!</p>


              </p>
              <Grid
                container
                direction="row"
                justify="center"
                md={11}
                className="mt-4"
              >
                <Grid
                  container
                  direction="row"
                  justify="center"
                xs={12}
                sm={12}
                // className="pcc---whitepapercard my-5 p-5"
                >
                 
                 
                </Grid>
              </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Whitepaperbody;
